import React from "react";
import News from "../Components/News/News";



const SneakerNews = () =>{
    return (
        <div>
            <News/>
            
        </div>
    )

}
export default SneakerNews